<template>
 <label :for="inputId" class="form-label"
          >{{ labelText }}
        </label>
        <textarea class="form-control" :id="inputId" v-model="inputField" maxlength="1000"></textarea>
        <span> {{ intl[$store.state.lang]["remaining-characters"]}}{{ 1000 - this.inputField.length }} {{ intl[$store.state.lang]["characters"] }}  </span>
     
</template>

<script>
import intl from "./intl/intl";


export default {
  name: "textArea",
  components: {
   
   
  },

  props: {
      
      inputId: {
        type: String,
        default: null
      },
      
      labelKey: {
        type: String,
        default: null
      },
      required: {
        type: Boolean,
        default: false
      },
     
        
  },
  mounted() {
   
  },
  beforeUnmount() {
    
  },
  data: function () {
    return {
      intl: intl,
      inputField: ""
    };
  },
  methods: {
     requiredInputIsOk(){
       if(this.required && this.inputField === ""){
         return false

       }
       return true
     }
  
         
               
    
  
    
  },
  watch: {
   

  },
  computed: {
        labelText: function () {
      if(this.required){
        return this.intl[this.$store.state.lang][this.labelKey] + '*:'
      }else{
        return this.intl[this.$store.state.lang][this.labelKey] + ':'
      }
       
    },
    },
  
};
</script>
